import { render } from "./SingleQuestion.vue?vue&type=template&id=c5e5b9d4&scoped=true"
import script from "./SingleQuestion.vue?vue&type=script&lang=js"
export * from "./SingleQuestion.vue?vue&type=script&lang=js"

import "./SingleQuestion.vue?vue&type=style&index=0&id=c5e5b9d4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5e5b9d4"]])

export default __exports__